import {
  DoubleSide,
  EquirectangularReflectionMapping,
  Mesh,
  MeshBasicMaterial,
  SphereGeometry,
  SRGBColorSpace,
  Texture,
  TextureLoader,
  Vector3,
} from 'three';

import { isDefined } from '../../../utils/variables';
import { Poi } from '../poi/poi';

export class PanoramaSphere extends Mesh {
  private loader = new TextureLoader();
  private currentTex: Texture | null = null;

  private activePoi?: Poi;

  constructor(radius = 500) {
    const geo = new SphereGeometry(radius, 30, 30);
    geo.scale(-1, 1, 1);

    const mat = new MeshBasicMaterial({ side: DoubleSide });
    super(geo, mat);

    this.rotateX(Math.PI / 2);
  }

  setHeading(headingDegree: number) {
    this.setRotationFromAxisAngle(new Vector3(0, 1, 0), headingDegree);
    if (!isDefined(this.activePoi)) {
      return;
    }

    this.activePoi.setRotationFromAxisAngle(new Vector3(0, 1, 0), headingDegree);
  }

  getActivePoi() {
    return this.activePoi;
  }

  async setPoi(poi: Poi) {
    this.activePoi = poi;

    const loadOriginalTexture = async () => {
      const url = poi.getThumbnailResourceUrl('original')!;
      const texture = await this.loader.loadAsync(url);
      this.setTexture(texture);
    };

    const previewImageUrl = poi.getThumbnailResourceUrl('512x_')!;
    const previewTexture = await this.loader.loadAsync(previewImageUrl);

    this.setTexture(previewTexture);

    void loadOriginalTexture();
  }

  dispose() {
    this.geometry.dispose();
    if (this.currentTex) {
      this.currentTex.dispose();
    }
  }

  private setTexture(texture: Texture) {
    texture.mapping = EquirectangularReflectionMapping;
    texture.colorSpace = SRGBColorSpace;
    texture.needsUpdate = true;

    if (isDefined(this.currentTex)) {
      this.currentTex.dispose();
    }
    (this.material as MeshBasicMaterial).map = texture;
    (this.material as MeshBasicMaterial).needsUpdate = true;
    this.currentTex = texture;
  }
}
